import { IconButton } from "@mui/material"
import { CollapsibleCard } from "components/CollapsiblCard/CollapsibleCard"
import { PersonTitleBox } from "components/PersonTitleBox/PersonTitleBox"
import { DeviceSetup, Examination, TestData } from "graphql/types"
import { useState } from "react"
import { getIconForTaskStep, getTextForTaskStep2 } from "utils/taskSteps"
import { TaskStepDataSwitch } from "./TaskStepDataSwitch"

type ReportTaskDataCardProps = {
  testData: TestData
  deviceSetup: DeviceSetup[]
  examination: Examination
}

export const ReportTaskDataCard = (props: ReportTaskDataCardProps) => {
  const { testData, deviceSetup, examination } = props
  const [open, setOpen] = useState(false)

  return (
    <CollapsibleCard
      key={testData.id}
      title={testData.name === "" ? getTextForTaskStep2(testData.type) : testData.name}
      subheader={
        <PersonTitleBox createdAt={testData.createdAt} person={testData.createdBy || undefined} />
      }
      avatar={<IconButton>{getIconForTaskStep(testData.type)}</IconButton>}
      open={open}
      onToggle={() => setOpen(!open)}
    >
      <TaskStepDataSwitch testData={testData} deviceSetup={deviceSetup} examination={examination} />
    </CollapsibleCard>
  )
}
